import { Components, stepIconClasses, Theme } from '@mui/material';

export const MuiStepContent: Components<Theme>['MuiStepContent'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        borderColor: theme.palette.stepper.connectorColor,
      };
    },
  },
};

export const MuiStepIcon: Components<Theme>['MuiStepIcon'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        color: theme.palette.stepper.iconBackground,

        [`&.${stepIconClasses.active},&.${stepIconClasses.completed}`]: {
          color: theme.palette.stepper.activeIconBackground,

          [`.${stepIconClasses.text}`]: {
            fill: theme.palette.stepper.activeIconColor,
          },
        },
        [`&.${stepIconClasses.completed}`]: {
          // The checkbox icon gets its color from the background, so we need to change the background to modify it.
          background: theme.palette.stepper.activeIconColor,
          // Force border radius, so that the background doesn't show outside the circle.
          borderRadius: '100%',
        },
      };
    },
    text: ({ theme }) => {
      return {
        fill: theme.palette.stepper.iconColor,
        fontWeight: theme.featureFlags.panwRebrandStubYear ? theme.typography.fontWeightBold : undefined,
      };
    },
  },
};

export const MuiStepConnector: Components<Theme>['MuiStepConnector'] = {
  styleOverrides: {
    line: ({ theme }) => {
      return {
        borderColor: theme.palette.stepper.connectorColor,
      };
    },
  },
};
